import React from 'react';
import { useNavigate } from 'react-router-dom';

const ROUTES = [
  { from:'JFK', to:'LAX', fromCity:'New York',     toCity:'Los Angeles',  price:89,  dur:'5h 30m', col:'from-blue-700 to-cyan-600',    save:'62%' },
  { from:'ORD', to:'MIA', fromCity:'Chicago',      toCity:'Miami',        price:71,  dur:'3h 10m', col:'from-cyan-700 to-blue-800',    save:'55%' },
  { from:'LAX', to:'LAS', fromCity:'Los Angeles',  toCity:'Las Vegas',    price:49,  dur:'1h 05m', col:'from-blue-800 to-indigo-600',  save:'68%' },
  { from:'ATL', to:'JFK', fromCity:'Atlanta',      toCity:'New York',     price:94,  dur:'2h 35m', col:'from-indigo-700 to-cyan-500',  save:'44%' },
  { from:'SFO', to:'SEA', fromCity:'San Francisco',toCity:'Seattle',      price:58,  dur:'2h 20m', col:'from-cyan-600 to-blue-700',    save:'57%' },
  { from:'BOS', to:'DCA', fromCity:'Boston',       toCity:'Washington DC',price:79,  dur:'1h 25m', col:'from-blue-700 to-cyan-500',    save:'51%' },
];

export default function PopularRoutes() {
  const navigate = useNavigate();
  const today = new Date().toISOString().split('T')[0];
  return (
    <section className="py-12 sm:py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 sm:mb-10">
          <span className="inline-block text-xs font-bold text-blue-700 uppercase tracking-widest bg-blue-50 border border-blue-100 px-4 py-1.5 rounded-full mb-3">Top Deal Routes</span>
          <h2 className="text-3xl sm:text-4xl font-black text-gray-900 mb-2">America's Best Flight Deals</h2>
          <p className="text-gray-500 text-sm sm:text-base">The most searched US routes — with the lowest fares we've found today</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5">
          {ROUTES.map(r => (
            <div key={r.from+r.to} onClick={() => navigate('/flights?origin='+r.from+'&destination='+r.to+'&date='+today+'&adults=1&tripType=oneway&class=economy&passengers=1')}
              className={'group bg-gradient-to-br '+r.col+' rounded-2xl p-5 sm:p-6 text-white cursor-pointer hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 relative overflow-hidden'}>
              <div className="absolute top-3 right-3 bg-yellow-400 text-blue-900 text-xs font-black px-2 py-0.5 rounded-full">SAVE {r.save}</div>
              <div className="flex items-center justify-between mb-4 mt-2">
                <div><p className="text-3xl font-black">{r.from}</p><p className="text-white/70 text-xs">{r.fromCity}</p></div>
                <div className="flex flex-col items-center gap-1">
                  <div className="flex items-center gap-1 w-20"><div className="h-px flex-1 bg-white/40"/><span className="text-sm">✈</span><div className="h-px flex-1 bg-white/40"/></div>
                  <span className="text-white/50 text-xs">{r.dur}</span>
                </div>
                <div className="text-right"><p className="text-3xl font-black">{r.to}</p><p className="text-white/70 text-xs">{r.toCity}</p></div>
              </div>
              <div className="flex items-center justify-between pt-3 border-t border-white/20">
                <div><p className="text-xs text-white/60">Deal fare from</p><p className="text-2xl font-black">${r.price}</p></div>
                <span className="bg-white/15 border border-white/20 text-white text-xs font-bold px-3 py-1.5 rounded-xl group-hover:bg-white group-hover:text-blue-700 transition-all">Find Deal →</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
